import React from 'react';
import FileStorage from '../components/FileStorage';

const ExecutiveSummary = () => {
  return (
    <FileStorage
      category="executive-summary"
      title="Executive Summary"
      description="Company overview, business plan summary, and strategic vision documents"
    />
  );
};

export default ExecutiveSummary;